/*
 * @Description: 混凝土订单
 * @Author: fxg
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-11-13 15:13:23
*/
import request from '@/utils/request'

export const queryPage = '/icps/system/sign/basics/plan/WXoutsourcePlansPage';


/**
 * 运输任务:获取运输记录列表
 * @param {object} data planId:计划编号
 */
export function WXqueryCarriageList(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/WXqueryCarriageList',
    method: 'post',
    data
  })
}

/**
 * 订单列表-获取罐车列表
 * @param {object} data contractId:合同编号
 */
export function WXgetTankercarList(data) {
  return request({
    url: '/icps/system/sign/supplierSystem/car/WXgetTankercarList',
    method: 'post',
    data
  })
}

/**
 * 订单列表-获取分配的罐车列表
 * @param {object} data planId:计划编号
 */
export function queryAllByplanId(data) {
  return request({
    url: '/icps/system/sign/intelligent/allocationTanker/queryAllByplanId',
    method: 'post',
    data
  })
}

/**
 * 订单列表-保存分配罐车
 * @param {object} data planId:计划编号, carNo: 'ss,sss'
 */
export function saveTankCar(data) {
  return request({
    url: '/icps/system/sign/intelligent/allocationTanker/save',
    method: 'post',
    data
  })
}

// 保存运输记录
export function saveDispatchLogisticsOrder(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/saveDispatchLogisticsOrder',
    method: 'post',
    data
  })
}